/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_cp_invalid = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enter a deposit, rate, and number of years.`)
};

const es_cp_invalid = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ingresa un depósito, una tasa y un número de años.`)
};

const de_cp_invalid = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Geben Sie eine Einzahlung, einen Zinssatz und eine Anzahl von Jahren ein.`)
};

const nl_cp_invalid = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Voer een bedrag, rentepercentage en aantal jaren in.`)
};

const fr_cp_invalid = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Entrez un dépôt, un taux et un nombre d'années.`)
};

const it_cp_invalid = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inserisci un deposito, un tasso e un numero di anni.`)
};

const pt_br2_cp_invalid = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Digite um depósito, uma taxa e um número de anos.`)
};

const pt_cp_invalid = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Introduza um depósito, taxa e número de anos.`)
};

const ja_cp_invalid = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`預金、利率、年数を入力してください。`)
};

const zh_cp_invalid = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`请输入存款金额、利率和年数。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const cp_invalid = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.cp_invalid(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("cp_invalid", locale)
	if (locale === "en") return en_cp_invalid(inputs)
	if (locale === "es") return es_cp_invalid(inputs)
	if (locale === "de") return de_cp_invalid(inputs)
	if (locale === "nl") return nl_cp_invalid(inputs)
	if (locale === "fr") return fr_cp_invalid(inputs)
	if (locale === "it") return it_cp_invalid(inputs)
	if (locale === "pt-BR") return pt_br2_cp_invalid(inputs)
	if (locale === "pt") return pt_cp_invalid(inputs)
	if (locale === "ja") return ja_cp_invalid(inputs)
	return zh_cp_invalid(inputs)
};